<template>
  <div>
    <template v-if="false">
      <h2>********* OBJ </h2>
      <p>{{log}} </p>
    </template>
    <h2>********* CREATED_AT </h2>
    <p>{{log._created_at}} </p>

    <h2>********* STARTED_AT </h2>
    <p>{{log._started_at}} </p>

    <h2>********* ENDED_AT </h2>
    <p>{{log._ended_at}} </p>

    <h2>********* NOTE </h2>
    <p v-if="true">{{ log.note } </p>
    <tip-tap-output
        v-if="Array.isArray(log.note)"
        :content="log.note"
    />

    <h2>********* CALL TYPE </h2>
    <p>{{log.callType}} </p>

    <h2>********* IMAGE </h2>
    <p>{{log.imgURL}} </p>

    <h2>********* REASON </h2>
    <p>{{log.objective}} </p>

    <h2>********* OUTCOME </h2>
    <p>{{log.outcome}}</p>

    <h2>********* REFERENCE # </h2>
    <p>{{log.refNum}}</p>

    <h2>********* STATUS </h2>
    <p>{{log.status}}</p>

    <h2>********* OUTBOUND? </h2>
    <p>{{log.isOutbound? 'Outbound' :'Inbound'}} </p>

    <h2>********* CREATED_BY</h2>
    <p>{{log._created_by}} </p>
  </div>
</template>
<script>
import moment from "moment";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "CallLog_DetailView",
  components: {
    TipTapOutput
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    log: {
      type: Object,
      default: () => {}
    },
  },
  created() {},
  mounted() {},
  computed: {
    createdAt(){
      return "time";
      return this.log && this.log._created_at?
          moment(new Date(this.log._created_at)).format("MMMM DD YYYY") : 'Not Set'
    },
    note(){
      return "ok";
      return this.log && this.log.note?
          this.note : 'Not Set';
    },
    createdBy() {
      return "ok";
      return this.log && this.log._created_by && this.log._created_by.name ?
          this.log._created_by.name : {};
    }
  },
  methods: {},
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
